<template>
    <div class="company base-pad">
        <div class="title">
            <img :src="zh_en == 'zh' ? STATICURL + bgimg.product_bgimg : STATICURL + bgimg.product_bgimg_en"
                style="width: 100%;height: 100%;" alt="">

        </div>

        <img src="../static/images/shopBack.png" style="width: 100%; position: absolute;bottom: 0;left: 0;" alt="">

        <div class="content">
            <div class="detail" v-if="isShowList">
                <div class="titlebox">
                    {{ zh_en == 'zh' ? '产品与介绍' : ' Introduction' }}
                </div>

                <div style="display: flex;justify-content: space-between;">
                    <div style="width: 20%;padding: 15px;box-sizing: border-box;">

                        <div v-for="(item, index) in tabList" :key="index" @click="change(item.id, index)"
                            style="border-bottom: 1px solid #E3E3E3;padding: 12px;box-sizing: border-box;">
                            <div class="default" :class='activityIndex == index ? "activity" : ""'>{{ zh_en == 'zh' ?
                                item.title : item.title_en }}
                            </div>

                        </div>

                    </div>
                    <div style="width: 80%;display: flex;flex-wrap: wrap;position: relative;">
                        <div style="width: 32%;margin-right: 1%;text-align: left;" v-for="(item, index) in product_list"
                            @click="goDetail(item)" :key="index">
                            <img :src="staticUrl + item.image" alt="" style="width: 100%;height: 180px;">
                            <div>{{ item.title }} </div>
                            <div style="color: #ccc;font-size: 14px;">{{ item.keywords }}</div>

                        </div>

                        <div style="position: absolute;bottom: -40px; left: 0;right: 0;margin: auto;">
                            <el-pagination background layout="prev, pager, next" :total="total" :page-size="6"
                                @current-change="currentChange">
                            </el-pagination>
                        </div>
                    </div>
                </div>

            </div>



            <div class="detail" style="text-align: left;" v-else>

                <div style="color: #8a2e26;font-size: 22px;">{{ shopDetail.title }}</div>
                <div style="color: #ccc;font-size: 14px;">{{ shopDetail.format }}</div>
                <div style="font-size: 16px;">{{ shopDetail.abstract }}</div>
                <div style="margin: 15px 0;width: 100px;height: 30px;color: #8a2e26;line-height: 30px;text-align: center;border-radius: 5px;background-color: rgba(138,46,38,0.05); border: 1px solid #8a2e26;"
                    @click="isShowList = true">{{ zh_en == 'zh' ? '查看更多' : 'see more' }}</div>

                <div>
                    <img :src="staticUrl + item" v-for="(item, index) in getImages(shopDetail.images)" :key="index"
                        alt=""
                        style="width: 250px;height: 180px;border: 1px #ccc solid;border-radius: 10px;margin-right: 15px;">
                </div>
                <div
                    style="width: 100%;height: 40px;margin: 20px 0; display: flex;background-color: rgba(245,245,245,1);border-bottom: 1px solid #8a2e26;">
                    <div v-for="(item, index) in detailList" :key="index" @click="changeDetailIndex(index)"
                        style="display: flex;justify-content: center;align-items: center;font-size: 14px;padding: 0px 10px;"
                        :class="detailIndex == index ? 'activityDetail' : 'defaultDetail'">
                        {{ item }}
                    </div>


                </div>

                <div
                    style="width: 70%; margin: 20px auto;display: flex;justify-content: space-between;align-items: center;height: 40px;">
                    <div style="width: 100px;height: 1px;background-color: #8a2e26;"></div>
                    <div style="color: #8a2e26;font-size: 24px;">{{ detailList[detailIndex] }}</div>
                    <div style="width: 100px;height: 1px;background-color: #8a2e26;"></div>
                </div>


                <div v-html="detailIndex == 0 ? shopDetail.content : shopDetail.honor_content">

                </div>
            </div>
        </div>

        <HomeFooter />
    </div>
</template>

<script>
import HomeFooter from '@/components/HomeFooter.vue';

// get_product_category_list
import {
    get_product_category_list,
    get_product_list
} from "@/api/api";
export default {
    data() {
        return {
            tabList: [{
                id: null,
                title: "全部产品",
                title_en: 'all'

            }],
            total: 0,
            detailList: this.zh_en == 'zh' ? ['产品说明书', '荣誉、资质'] : ['Product Description', 'Honors 、 Qualification'],
            staticUrl: this.STATICURL,
            product_list: [],
            postData: {
                per_page: 6,
                page: 1,
                category_id: null
            },
            detailIndex: 0,
            activityIndex: 0,
            isShowList: true,
            shopDetail: ''
        }
    },
    components: {
        HomeFooter
    },
    mounted() {
        this.get_product_category_list()
        this.change(null, 0)
    },
    methods: {
        currentChange(e) {
            this.postData.page = e
            this.get_product_list()
        },
        getImages(images) {
            return images.split(',')
        },
        changeDetailIndex(e) {
            this.detailIndex = e
        },
        goDetail(item) {
            this.isShowList = false
            this.shopDetail = item
            this.changeDetailIndex(0)

        },
        change(item, index) {
            this.activityIndex = index
            console.log(item);
            this.postData.category_id = item
            this.postData.page = 1
            this.get_product_list()
        },
        get_product_category_list() {
            get_product_category_list().then(res => {
                this.tabList = this.tabList.concat(res)
            })
        },
        get_product_list() {
            get_product_list(this.postData).then(res => {
                console.log(res);
                this.product_list = res.data
                this.total = res.total
            })
        }
    }

}
</script>


<style lang="less" scoped>
.activityDetail {
    background-color: #8A2E26;
    color: #fff;
}

.defaultDetail {
    color: #000;
    background-color: rgba(245, 245, 245.1);
    border-right: 1px solid #8A2E26;
    border-left: 1px solid #8A2E26;

}

.default {
    font-size: 15px;
    padding: 0px 12px;
    display: flex;
    text-align: left;
    align-items: center;
    box-sizing: border-box;
    border-left: 2px solid transparent;

}

.activity {
    font-size: 15px;
    color: #8A2E26;
    border-left: 2px solid #8A2E26;
}

.content {
    width: 100%;
    padding: 48px;
    box-sizing: border-box;
    position: relative;

    .detail {
        .titlebox {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 228px;
            height: 68px;
            background-image: url(@/static/images/shopTitle.png);
            background-size: 100% 100%;
            margin: 0 auto;
            color: #8A2E26;
            font-size: 28px;
            margin-bottom: 40px;
            font-weight: bold;
        }

        width: 60%;
        margin: 0 auto;
    }
}

.company {
    position: relative;
}

.title {
    width: 100%;
    height: 360px;
    background-color: #d3dce6;

}
</style>